import React, { PropTypes } from 'react'
import ContractTable from '../../components/contract/ContractTable';
import { connect } from 'react-redux'
import { fetchMessagesIfNeeded, approveMessage,replyMessage } from '../../actions/ContactAction';

import { showModal, hideModal } from '../../actions/ModalAction'
import { MODEL_TYPE_CONFIRM, MODEL_TYPE_CONTACT_REPLY } from '../modal/ModalRoot'

class Contact extends React.Component{

  componentDidMount() {
    this.props.onLoadData()
  }

  render(){

    if (this.props.isFetching && this.props.posts.length == 0) {
      return <p>Loading...</p>
    }

    return <ContractTable posts={this.props.posts}
              onClickApproveButton={this.props.onClickApproveButton}
              onClickReplyButton={this.props.onClickReplyButton}
            />
  }
}

Contact.propTypes = {
  posts: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    posts: state.contact.posts,
    isFetching: state.contact.isFetching
  }
}

const mapDispatchToProps = (dispatch) => {

  return {
    onLoadData: ()=>{
      dispatch(fetchMessagesIfNeeded());
    },
    onClickApproveButton: (messageId, isTop) => {
      dispatch(
        showModal(MODEL_TYPE_CONFIRM, {
          body:'承認しますか',
          onConfirm: ()=>{
            dispatch(hideModal())
            dispatch(approveMessage(messageId, isTop));
          },
          onCancel: ()=>{
            dispatch(hideModal())
          }
        }))
    },
    onClickReplyButton: (messageId) => {
      dispatch(
        showModal(MODEL_TYPE_CONTACT_REPLY, {
          onConfirm: (message)=>{
            dispatch(hideModal())
            dispatch(replyMessage(messageId, message));
          },
          onCancel: ()=>{
            dispatch(hideModal())
          }
        }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/pages/board/Contact.js